/*
 * Generated on 8/28/2025, 11:07:33 AM
 * Do not edit this file, any changes will be overwritten
 */

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function openPopup(pUrl, pWidth, pHeight) {
  if (!pWidth) pWidth = 800;
  if (!pHeight) pHeight = 600;
  var sWidth = screen.availWidth;
  var sHeight = screen.availHeight;
  var pTop = sHeight / 2 - pHeight / 2;
  var pLeft = sWidth / 2 - pWidth / 2;
  console.log(pWidth, pHeight, pTop, pLeft);
  window.open(pUrl, 'popup', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes' + ',width=' + pWidth + ',height=' + pHeight + ',top=' + pTop + ',left=' + pLeft);
}
function checkSidebarHeight() {
  $('.sidebar').each(function () {
    var sidebarHeight = $(this).outerHeight(true);
    var windowHeight = $(window).height();
    windowHeight -= $('.navbar-fixed-top').outerHeight();
    if (sidebarHeight > windowHeight) {
      $(this).addClass('no-affix');
    } else {
      $(this).removeClass('no-affix');
    }
  });
}
function printOnly($element) {
  $('body').addClass('print-nothing');
  $element.addClass('print');
  window.print();
  $element.removeClass('print');
  $('body').removeClass('print-nothing');
}
function isScrolledIntoView($element) {
  if ($element.length == 0 || !$element.is(':visible')) {
    return false;
  }
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $element.offset().top;
  var elemBottom = elemTop + $element.height();
  return elemBottom <= docViewBottom && elemTop >= docViewTop;
}
function getScrollbarWidth($element) {
  var remove = false;
  if (_typeof($element) == undefined) {
    remove = true;
    var $element = $('<div style="height:1px;overflow-y:scroll;"/>').appendTo('body');
  }
  var scrollbarWidth = $element[0].offsetWidth - $element[0].clientWidth;
  if (remove) $element.remove();
  return scrollbarWidth;
}
var showKPIScoresRequest = {
  abort: function abort() {}
};
var postKPIScoresRequest = {
  abort: function abort() {}
};
function monitorKPIScores(itemSelector, answerUrl, callback) {
  $(itemSelector).filter('[type=number]').on('input', function (e, extra) {
    var $item = $(this);
    updateKPIScores($item, answerUrl, callback, $(this));
  });
  $(itemSelector).filter('[type!=number]').on('change', function (e, extra) {
    var $item = $(this);
    updateKPIScores($item, answerUrl, callback, $(this));
  });
}
function updateKPIScores($item, answerUrl, callback, changedElement) {
  if ($item.is(':disabled')) {
    return;
  }
  var $span = $item.closest('span');
  var $clone = $item.clone();
  var $form = $('<form />');
  if ($clone.attr('type') == 'checkbox' && !$clone.is(':checked')) {
    $clone.val('0').attr('type', 'hidden');
  }
  $clone.appendTo($form);
  $span.addClass('loading');
  postKPIScoresRequest.abort();
  showKPIScoresRequest.abort();
  if (answerUrl == '') {
    $span.removeClass('loading');
    if (typeof callback == 'function') {
      callback(changedElement);
    }
    return;
  }
  postKPIScoresRequest = $.post(answerUrl, $form.serialize(), function (data) {
    if (data == 'ok') {
      $span.removeClass('loading');
      if (typeof callback == 'function') {
        callback(changedElement);
      }
    }
  });
}
function showKPIScores(simulate, callback) {
  showKPIScoresRequest.abort();
  var formData = {};
  if (simulate) {
    var $form = $('form[name=scores_form]');
    var $disabled = $form.find(':input:disabled').removeAttr('disabled');
    formData = $form.serializeArray();
    $disabled.attr('disabled', 'disabled');
  }
  showKPIScoresRequest = $.getJSON('/site/ajax/get_kpi_scores.php', formData, function (data) {
    for (var kpi_nr in data.scores_perc) {
      $('.score-button[data-menu-button="kpi_' + kpi_nr + '"] .progress-score').width(data.scores_perc[kpi_nr] + '%');
      $('.score-button[data-menu-button="kpi_' + kpi_nr + '"] .progress-goal').width(data.goals_perc[kpi_nr] + '%');
    }
    $('.kpi-quarter-warning').addClass('hidden');
    $.each(data.warnings, function (type, type_warnings) {
      $.each(type_warnings, function (kpi_nr, kpi_warnings) {
        $.each(kpi_warnings, function (quarter, quarter_warning) {
          $('.kpi-quarter-warning[data-type="' + type + '"][data-kpi="' + kpi_nr + '"][data-quarter="' + quarter + '"]').attr('data-warning', quarter_warning).removeClass('hidden');
        });
      });
    });
    setGrayGlassHeight(data.year_score_perc);
    setGlassHeight(data.year_goal_perc);
    $('.counter-perc').counter({
      start: parseFloat($('.counter-perc').data('counter-current')),
      end: data.year_score_perc,
      duration: 500,
      decimals: 1
    });
    $('.counter-score').counter({
      start: parseFloat($('.counter-score').data('counter-current')),
      end: data.score_total,
      duration: 500,
      decimals: 0
    });
    $('.counter-goal').counter({
      start: parseFloat($('.counter-goal').data('counter-current')),
      end: data.goal_total,
      duration: 500,
      decimals: 0
    });
    $('.counter-credits').counter({
      start: parseFloat($('.counter-credits').data('counter-current')),
      end: data.credits,
      duration: 500,
      decimals: 0
    });
    if (typeof callback == 'function') {
      callback();
    }
  });
}
function setGrayGlassHeight(perc) {
  $('.progress-glass-bar-2').show().animate({
    'height': perc + '%'
  }, 500, function () {
    if (perc == 0) {}
  });
}
function setGlassHeight(perc) {
  $('.progress-glass-bar-1').show().animate({
    'height': perc + '%'
  }, 500, function () {
    if (perc == 0) {}
  });
}
var Menu = function () {
  var currentScrollTop = 0;
  $(document).ready(function () {
    var scrollBarWidth = getScrollbarWidth();
    $('.navbar-collapse').on('show.bs.collapse', function (e) {
      $('.navbar-toggle').addClass('active');
      $('body').addClass('scroll-disabled');
    });
    $('.navbar-collapse').on('hide.bs.collapse', function (e) {
      $('.navbar-toggle').removeClass('active');
      $('body').removeClass('scroll-disabled');
    });
    $('.navbar-main .has-submenu > a').on('click', function (e) {
      var $submenu = $(this).parent().find('.navbar-subnav');
      if (!$submenu.is(':visible') || $submenu.height() == 0) {
        e.preventDefault();
        $submenu.slideDown('fast');
      }
    });
    $('.open-navbar-search').on('click', function (e) {
      e.preventDefault();
      $(this).closest('.navbar-search').addClass('focus').find('input').focus();
    });
    $(document).on('click', function () {
      $('.navbar-search').removeClass('focus');
    });
    $('.navbar-search').on('click', function (e) {
      e.stopPropagation();
    });
    $('a[data-target-popin-menu]').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      if ($(this).hasClass('disabled')) {
        return;
      }
      var showContainer = $(this).data('target-popin-menu');
      $('.nav-popin-menu').not(showContainer).removeClass('active');
      if ($(showContainer).hasClass('active')) {
        $(showContainer).removeClass('active');
      } else {
        $(showContainer).addClass('active');
        $(window).trigger('resize-popin-menu');
      }
    });
    $(document).on('click', function (e) {
      $('.nav-popin-menu').removeClass('active');
    });
    $('.nav-popin-menu').on('click', function (e) {});
  });
  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      $('.navbar-top .icon-button[data-toggle="collapse"].active').click();
    }
  });
  var setScrollTop = function setScrollTop() {
    currentScrollTop = window.scrollTop;
  };
  var getScrollbarWidth = function getScrollbarWidth() {
    var $div = $('<div />').css({
      width: '100px',
      height: '100px',
      overflow: 'scroll',
      position: 'absolute',
      top: '-9999px'
    }).appendTo($('body'));
    var scrollbarWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
    $div.remove();
    return scrollbarWidth;
  };
}();
$(function () {
  checkCustomInputs();
  $('[data-background], img[data-src]').imageLoader();
  $('a.popup').click(function (e) {
    e.preventDefault();
    openPopup($(this).attr('href'), $(this).data('popup-width'), $(this).data('popup-height'));
  });
  $(document).on('click', 'a.confirm', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $popin = $('.confirm-popin');
    var textYes = $(this).data('text-yes') || $popin.find('.yes').data('text-yes');
    var textNo = $(this).data('text-no') || $popin.find('.no').data('text-no');
    var onConfirm = $(this).data('onconfirm') || '';
    if ($popin.is(':visible')) {
      return;
    }
    $popin.find('.text').html($(this).data('confirm'));
    $popin.find('.yes').removeAttr('onclick').attr('href', $(this).attr('href')).text(textYes);
    $popin.find('.no').text(textNo);
    $popin.modal();
    if (onConfirm) {
      $popin.find('.yes').attr('onclick', onConfirm);
    }
  });
  $(document).on('click', 'a.show-alert', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $popin = $('.alert-popin');
    if ($popin.is(':visible')) {
      return;
    }
    $popin.find('.text').html($(this).data('alert'));
    $popin.modal();
  });
  $('input[type=number]').keyup(function () {
    var min = parseInt($(this).attr('min'));
    var max = parseInt($(this).attr('max'));
    var value = parseInt($(this).val());
    if (!isNaN(max) && value > max) {
      $(this).val(max);
    }
    if (!isNaN(min) && value < min) {
      $(this).val(min);
    }
  });
  $('.toggle-pass').on('mousedown', function (e) {
    e.preventDefault();
    var $passField = $(this).parent().find('input');
    var $icon = $(this).find('i');
    var newType = $passField.attr('type') == 'text' ? 'password' : 'text';
    $passField.attr('type', newType).focus();
    newType == 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
  }).on('click', function (e) {
    e.preventDefault();
  });
  $('.modal').on('show.bs.modal', function (e) {
    $('body').addClass('modal-active');
  }).on('hide.bs.modal', function (e) {
    $('body').removeClass('modal-active');
  });
  $(window).resize(function () {
    checkSidebarHeight();
  }).resize();
  $('.dashboard-scores').on('click', function () {
    var targetUrl = $(this).data('scores-url');
    window.location.href = targetUrl;
  });
});
var dateTimePickerIcons = {
  time: 'fa fa-clock',
  date: 'fa fa-calendar',
  up: 'fa fa-chevron-up',
  down: 'fa fa-chevron-down',
  previous: 'fa fa-chevron-double-left',
  next: 'fa fa-chevron-double-right',
  today: 'fa fa-crosshairs',
  clear: 'fa fa-trash',
  close: 'fa fa-times'
};
$(window).on('mousewheel', function () {
  $(window).trigger('scroll');
});
setInterval(function () {
  $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);